import { render, staticRenderFns } from "./dorInterfaceReport.vue?vue&type=template&id=13d166be&scoped=true&"
import script from "./dorInterfaceReport.vue?vue&type=script&lang=js&"
export * from "./dorInterfaceReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d166be",
  null
  
)

export default component.exports